import { Component, output, ViewChild } from '@angular/core';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'tgcs-qr-scanner',
  standalone: true,
  imports: [ ButtonModule, ZXingScannerModule  ],
  templateUrl: './qr-scanner.component.html',
  styleUrl: './qr-scanner.component.scss'
})
export class QrScannerComponent {

  ngOnInit() {
    setTimeout(() => {      
      this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
        let backCamera = devices.find(device => device.label.toLowerCase().includes('back'));
        if (backCamera) {
            this.scanner.device = backCamera;
        }
      });      
    }, 100);
  }

  @ViewChild('scanner') scanner!: ZXingScannerComponent;

  qrCodeCaptured = output<string>(); 
  closeCamera = output<void>(); 

  qrCodeCapturedHandler(qrValue: string) {
    this.qrCodeCaptured.emit(qrValue);
  }

  closeCameraHandler() {
    this.closeCamera.emit();
  }
  
}
